import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    name: '',
    email: '',
    phoneNo: '',
    countryCode: '',
    showLandingPageTrendingSkills: false,
    fromLandingPage: false
}

const newSavedDataSlice = createSlice({
    name: 'newSavedData',
    initialState,
    reducers: {
        setNameToSavedData: (state, action) => {
            state.name = action.payload
        },
        setEmailAndPhone: (state, action) => {
            const { email, phoneNo, countryCode } = action.payload
            state.email = email
            state.phoneNo = phoneNo
            state.countryCode = countryCode
        },
        setShowLandingPageTrendingSkills: (state, action) => {
            state.showLandingPageTrendingSkills = action.payload
        },
        setFromLandingPage: (state, action) => {
            state.fromLandingPage = action.payload
        }
    }
})

export const selectNewSavedData = (state) => state.newSavedData
export const { setNameToSavedData, setEmailAndPhone, setShowLandingPageTrendingSkills, setFromLandingPage } = newSavedDataSlice.actions
export default newSavedDataSlice.reducer